import { handleResponse, handleError } from "./apiUtils";
import config from "../config";
//const baseUrl = "/api";
//const createlead = "/createlead";

export function createleadoncrm(body) {
  const createLeadUrl = config.CreateLeadRecord_URL;
  return fetch(createLeadUrl, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body: JSON.stringify(body),
  })
    .then(handleResponse)
    .catch(handleError);
}

